//  Client\client-vite\src\pages\Careers\CareersPage.tsx

import Earth from "@/components/ui/globe"
import { cn } from "@/lib/utils";
import { motion } from "framer-motion"

interface HeroSectionProps {
    title: string;
    subtitle?: string;
    gradientFrom?: string;
    gradientTo?: string;
    children?: React.ReactNode;
    className?: string;
}

export const CareersPage: React.FC<HeroSectionProps> = ({
    title,
    subtitle,
    gradientFrom = "from-sky-600",
    gradientTo = "to-indigo-700",
    children,
    className
}) => {
    return (
          <section
            className={cn(
                "relative overflow-hidden text-white py-20 px-6 flex flex-col items-center justify-center text-center rounded-b-3xl",
                "bg-gradient-to-br",
                gradientFrom,
                gradientTo,
                className
            )}
        >
            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                className="space-y-4 z-10"
            >
                <h1 className="text-5xl font-bold tracking-tight drop-shadow-lg">{title}</h1>
                {subtitle && (
                    <p className="text-lg text-white/90 max-w-2xl mx-auto">{subtitle}</p>
                )}
                {children}
            </motion.div>

            {/* Decorative globe animation */}
            <div className="absolute inset-0 opacity-25 pointer-events-none">
                <Earth />
            </div>
            
           <div>
                <h2 className="text-lg font-semibold mb-4">
                    Welcome to IDSCRM Careers Page
                </h2>
                <p className="text-sm text-gray-600">
                    This is the starting point. From here you'll manage dealers,
                    inventory, finance, and live for your company accounts must have be granted acccess by company.
                </p>
           </div>
        </section>


            
       
    )
}

export default CareersPage